(function () {
  'use strict';

  var currentShop = (window.Shopify && window.Shopify.shop) || '';

  var CONFIG_URL = 'https://fish.limm.space/api/v1/search/config';
  var SEARCH_URL = 'https://fish.limm.space/api/v1/predictive-search';
  var CONFIG_TTL = 5 * 60 * 1000; // 5 min
  var DEBOUNCE_MS = 200;
  var SEARCH_TIMEOUT_MS = 2000;
  var CONFIG_TIMEOUT_MS = 1500;
  var MIN_QUERY_LEN = 2;

  // Level 3: fetch config with sessionStorage cache
  function fetchSearchConfig() {
    var cached = sessionStorage.getItem('fish-search-config');
    var cachedAt = parseInt(sessionStorage.getItem('fish-search-config-at') || '0', 10);
    if (cached && Date.now() - cachedAt < CONFIG_TTL) {
      try { return Promise.resolve(JSON.parse(cached)); } catch (e) { /* fall through */ }
    }
    var ctrl = new AbortController();
    var tid = setTimeout(function () { ctrl.abort(); }, CONFIG_TIMEOUT_MS);
    return fetch(CONFIG_URL, { signal: ctrl.signal })
      .then(function (r) {
        clearTimeout(tid);
        if (!r.ok) throw new Error('config ' + r.status);
        return r.json();
      })
      .then(function (cfg) {
        sessionStorage.setItem('fish-search-config', JSON.stringify(cfg));
        sessionStorage.setItem('fish-search-config-at', String(Date.now()));
        return cfg;
      })
      .catch(function (err) {
        clearTimeout(tid);
        throw err;
      });
  }

  function bootstrap() {
    fetchSearchConfig()
      .then(function (config) {
        if (config && config.fish_search_enabled === true) {
          initFishPredictiveSearch();
        }
      })
      .catch(function () {
        console.warn('[predictive-search-fish] config unavailable, falling back to Dawn');
      });
  }

  // ── helpers ──────────────────────────────────────────────────────────────

  function addWidth(url, w) {
    if (!url) return '';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=' + w;
  }

  function escHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var ARROW_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-arrow" viewBox="0 0 14 10">' +
    '<path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 ' +
    '.708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546"' +
    ' clip-rule="evenodd"></path></svg>';

  // ── render helpers ────────────────────────────────────────────────────────

  function renderProductItem(item, n) {
    var img = item.image
      ? '<img class="predictive-search__image" src="' + escHtml(addWidth(item.image, 150)) +
        '" alt="' + escHtml(item.title) + '" width="50" height="25" loading="eager" decoding="async">'
      : '';
    var kidsTag = item.is_kids
      ? '<span class="kidsBadge fish-ps-tag-kids" aria-label="Kids size">KIDS SIZE</span>'
      : '';
    return (
      '<li id="predictive-search-option-product-' + n + '" class="predictive-search__list-item"' +
      ' role="option" aria-selected="false">' +
      '<a href="' + escHtml(item.url) + '"' +
      ' class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text"' +
      ' tabindex="-1">' +
      img +
      '<div class="predictive-search__item-content predictive-search__item-content--centered">' +
      '<div class="fish-ps-title-row">' +
      '<p class="predictive-search__item-heading h5">' + escHtml(item.title) + '</p>' +
      kidsTag +
      '</div>' +
      '</div>' +
      '</a></li>'
    );
  }

  function renderGenericItem(item, type, n) {
    return (
      '<li id="predictive-search-option-' + type + '-' + n + '" class="predictive-search__list-item"' +
      ' role="option" aria-selected="false">' +
      '<a href="' + escHtml(item.url) + '" class="predictive-search__item link link--text" tabindex="-1">' +
      '<div class="predictive-search__item-content predictive-search__item-content--centered">' +
      '<p class="predictive-search__item-heading h5">' + escHtml(item.title) + '</p>' +
      '<p class="predictive-search__item-vendor caption-with-letter-spacing"></p>' +
      '</div></a></li>'
    );
  }

  function renderQueryItem(item, n) {
    return (
      '<li class="predictive-search__list-item" role="option" aria-selected="false">' +
      '<a href="' + escHtml(item.url) + '" class="predictive-search__item link link--text" tabindex="-1">' +
      '<div class="predictive-search__item-content">' +
      '<p class="predictive-search__item-heading h5">' + escHtml(item.text || item.title) + '</p>' +
      '</div></a></li>'
    );
  }

  var i18n = window.FISH_SEARCH_I18N || {};
  var I18N_DEFAULTS = {
    group_queries: 'Suggested', group_collections: 'Collections',
    group_articles: 'Blog posts', group_pages: 'Pages', group_products: 'Products',
    no_results: 'No results for \u00ab{query}\u00bb',
    view_all:   'View all results for \u00ab{query}\u00bb',
    did_you_mean: 'Did you mean \u00ab{query}\u00bb?'
  };
  function ts(key, query) {
    var str = i18n[key] || I18N_DEFAULTS[key] || key;
    return query !== undefined ? str.replace(/\{query\}/g, escHtml(String(query))) : str;
  }

  var GROUP_LABELS = {
    queries:     ts('group_queries'),
    collections: ts('group_collections'),
    articles:    ts('group_articles'),
    pages:       ts('group_pages'),
    products:    ts('group_products')
  };
  var GROUP_ORDER = ['queries', 'collections', 'articles', 'pages', 'products'];

  function renderGroup(type, items) {
    if (!items || items.length === 0) return '';
    var itemsHtml = '';
    items.forEach(function (item, i) {
      if (type === 'products')    itemsHtml += renderProductItem(item, i);
      else if (type === 'queries') itemsHtml += renderQueryItem(item, i);
      else                        itemsHtml += renderGenericItem(item, type, i);
    });
    return (
      '<div class="predictive-search__result-group">' +
      '<div><h2 id="predictive-search-' + type + '"' +
      ' class="predictive-search__heading text-body caption-with-letter-spacing">' +
      escHtml(GROUP_LABELS[type] || type) + '</h2>' +
      '<ul id="predictive-search-results-' + type + '-list"' +
      ' class="predictive-search__results-list list-unstyled"' +
      ' role="group" aria-labelledby="predictive-search-' + type + '">' +
      itemsHtml +
      '</ul></div></div>'
    );
  }

  var LEFT_GROUPS  = ['queries', 'collections', 'pages', 'articles'];
  var RIGHT_GROUPS = ['products'];
  var LEFT_LIMITS  = { collections: 5, pages: 3, articles: 3 };

  function renderEmptyStateSuggestions(items) {
    var group = renderGroup('queries', items);
    if (!group) return '';
    return '<div class="fish-search-body">' + group + '</div>';
  }

  function renderResults(data) {
    var resources = (data && data.resources) || {};
    var totalResults = data.total_results || 0;
    var query = data.query || '';
    var html = '';

    var footerHtml =
      '<div id="predictive-search-option-search-keywords" class="predictive-search__search-for-button">' +
      '<button class="predictive-search__item predictive-search__item--term link link--text h5 animate-arrow"' +
      ' tabindex="-1" role="option" aria-selected="false" data-fish-submit>' +
      '<span>' + ts('view_all', query) + '</span>' +
      '<span class="svg-wrapper">' + ARROW_SVG + '</span>' +
      '</button></div>';

    if (totalResults === 0) {
      var didYouMean = data.did_you_mean;
      var dymHtml = '';
      if (didYouMean && didYouMean.text && didYouMean.url) {
        dymHtml =
          '<p class="predictive-search__item-heading h5 fish-ps-did-you-mean">' +
          '<a href="' + escHtml(didYouMean.url) + '" class="link link--text" tabindex="-1">' +
          ts('did_you_mean', didYouMean.text) +
          '</a></p>';
      }
      html = '<div class="fish-search-body">' +
        '<div class="predictive-search__no-results">' +
        '<p class="predictive-search__item-heading h5">' + ts('no_results', query) + '</p>' +
        dymHtml +
        '</div></div>' + footerHtml;
    } else {
      // Левая колонка: queries, collections, pages, articles — с лимитами строк
      var leftHtml = '';
      LEFT_GROUPS.forEach(function (type) {
        var group = resources[type];
        var items = group && group.items;
        if (items && LEFT_LIMITS[type]) items = items.slice(0, LEFT_LIMITS[type]);
        leftHtml += renderGroup(type, items);
      });

      // Правая колонка: products — максимум 15 строк
      var rightHtml = '';
      RIGHT_GROUPS.forEach(function (type) {
        var group = resources[type];
        var items = group && group.items;
        if (items) items = items.slice(0, 15);
        rightHtml += renderGroup(type, items);
      });

      var hasLeft  = leftHtml.trim().length > 0;
      var hasRight = rightHtml.trim().length > 0;

      var columnsHtml;
      if (hasLeft && hasRight) {
        columnsHtml =
          '<div class="fish-search-columns">' +
          '<div class="fish-search-col fish-search-col--right">' + rightHtml + '</div>' +
          '<div class="fish-search-col fish-search-col--left">'  + leftHtml  + '</div>' +
          '</div>';
      } else if (hasRight) {
        columnsHtml = '<div class="fish-search-col fish-search-col--full">' + rightHtml + '</div>';
      } else {
        columnsHtml = leftHtml;
      }

      // Body wrapper (flex container, not scrollable) + sticky footer outside
      html = '<div class="fish-search-body">' + columnsHtml + '</div>' + footerHtml;
    }

    // Live region
    var countParts = [];
    GROUP_ORDER.forEach(function (type) {
      var group = resources[type];
      var count = group && group.total;
      if (count) countParts.push(count + ' ' + (GROUP_LABELS[type] || type).toLowerCase());
    });
    html +=
      '<span class="hidden" data-predictive-search-live-region-count-value="">' +
      totalResults + ' results' + (countParts.length ? ': ' + countParts.join(', ') : '') +
      '</span>';

    return html;
  }

  // ── main init ─────────────────────────────────────────────────────────────

  function initFishPredictiveSearch() {
    var input = document.getElementById('Search-In-Navbar');
    var dropdown = document.getElementById('navbar-search-dropdown');
    var form = document.getElementById('navbar-search-form');
    if (!input || !dropdown || !form) return;

    var debounceTimer = null;
    var currentController = null;
    var bypassFishOnce = false;
    var closeTimer = null;
    var lastQuery = null;
    var isOpen = false;

    // ── open / close ────────────────────────────────────────────────────────

    var searchWrapper = form.closest('.navbarSearchWrapper');

    function openDropdown() {
      if (isOpen) return;
      isOpen = true;
      dropdown.style.display = 'flex';
      dropdown.style.flexDirection = 'column';
      dropdown.setAttribute('aria-expanded', 'true');
      // On mobile navbarSearchWrapper has overflow:hidden (for max-height animation)
      // which clips the absolutely-positioned dropdown — temporarily remove it
      if (searchWrapper) searchWrapper.style.overflow = 'visible';
    }

    function closeDropdown() {
      isOpen = false;
      dropdown.style.display = 'none';
      dropdown.setAttribute('aria-expanded', 'false');
      clearSelected();
      // Restore overflow so mobile collapse animation works correctly
      if (searchWrapper) searchWrapper.style.overflow = '';
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeDropdown, 150);
    }

    function cancelClose() {
      clearTimeout(closeTimer);
    }

    // ── keyboard selection ──────────────────────────────────────────────────

    function getOptions() {
      return Array.prototype.slice.call(
        dropdown.querySelectorAll('[role="option"]')
      );
    }

    function clearSelected() {
      getOptions().forEach(function (el) {
        el.setAttribute('aria-selected', 'false');
        el.classList.remove('predictive-search__item--active');
      });
    }

    function getSelectedIndex() {
      var opts = getOptions();
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].getAttribute('aria-selected') === 'true') return i;
      }
      return -1;
    }

    function selectOption(idx) {
      var opts = getOptions();
      clearSelected();
      if (idx >= 0 && idx < opts.length) {
        opts[idx].setAttribute('aria-selected', 'true');
        opts[idx].classList.add('predictive-search__item--active');
      }
    }

    // ── fetch ───────────────────────────────────────────────────────────────

    function showLoading() {
      dropdown.classList.add('predictive-search--loading');
    }

    function hideLoading() {
      dropdown.classList.remove('predictive-search--loading');
    }

    function commitSearch(q) {
      if (!q || q.trim().length < MIN_QUERY_LEN) return;
      var shopParam = currentShop ? '&shop=' + encodeURIComponent(currentShop) : '';
      fetch(SEARCH_URL + '?q=' + encodeURIComponent(q.trim()) + '&limit=1' + shopParam + '&committed=true').catch(function () {});
    }

    function fetchEmptySuggestions() {
      if (currentController) currentController.abort();
      currentController = new AbortController();
      var tid = setTimeout(function () { currentController.abort(); }, SEARCH_TIMEOUT_MS);

      var shopParam = currentShop ? '&shop=' + encodeURIComponent(currentShop) : '';
      var url = SEARCH_URL + '?q=&limit=8' + shopParam;

      fetch(url, { signal: currentController.signal })
        .then(function (r) {
          clearTimeout(tid);
          if (!r.ok) return null;
          return r.json();
        })
        .then(function (data) {
          if (!data) return;
          if (data.search_disabled === true) return;
          var items = data.resources && data.resources.queries && data.resources.queries.items;
          if (!items || !items.length) return;
          dropdown.innerHTML = renderEmptyStateSuggestions(items);
          openDropdown();
        })
        .catch(function (err) {
          clearTimeout(tid);
        });
    }

    function fetchResults(q) {
      if (!q || q.trim().length < MIN_QUERY_LEN) {
        closeDropdown();
        lastQuery = null;
        return;
      }
      if (q === lastQuery) return;
      lastQuery = q;

      if (currentController) currentController.abort();
      currentController = new AbortController();
      var tid = setTimeout(function () { currentController.abort(); }, SEARCH_TIMEOUT_MS);

      showLoading();
      openDropdown();

      var shopParam = currentShop ? '&shop=' + encodeURIComponent(currentShop) : '';
      var url = SEARCH_URL + '?q=' + encodeURIComponent(q) + '&limit=8' + shopParam;

      fetch(url, { signal: currentController.signal })
        .then(function (r) {
          clearTimeout(tid);
          if (r.status >= 500) throw Object.assign(new Error('server'), { status: r.status });
          if (!r.ok) {
            // 4xx: silent clear
            dropdown.innerHTML = '';
            closeDropdown();
            return null;
          }
          return r.json();
        })
        .then(function (data) {
          if (!data) return;
          // fish-поиск магазину не отдаётся (нет подписки / исчерпана квота) —
          // тихо уходим на нативный Dawn predictive, без сообщения покупателю.
          if (data.search_disabled === true) {
            hideLoading();
            bypassFishOnce = true;
            lastQuery = null;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            return;
          }
          hideLoading();
          dropdown.innerHTML = renderResults(data);
          openDropdown();
        })
        .catch(function (err) {
          clearTimeout(tid);
          if (err.name === 'AbortError') return;
          console.error('[predictive-search-fish] failed, falling back to Dawn', err);
          hideLoading();
          bypassFishOnce = true;
          lastQuery = null;
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
    }

    // ── input capture ────────────────────────────────────────────────────────

    input.addEventListener('input', function (e) {
      if (bypassFishOnce) {
        bypassFishOnce = false;
        return;
      }
      e.stopImmediatePropagation();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var v = input.value;
        if (!v || v.trim().length === 0) {
          lastQuery = null;
          fetchEmptySuggestions();
          return;
        }
        fetchResults(v);
      }, DEBOUNCE_MS);
    }, { capture: true });

    // ── keyboard navigation ───────────────────────────────────────────────────

    input.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      var opts = getOptions();
      var idx = getSelectedIndex();
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        selectOption(Math.min(idx + 1, opts.length - 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        selectOption(Math.max(idx - 1, 0));
      } else if (e.key === 'Enter') {
        e.preventDefault();
        var q = input.value.trim();
        if (idx >= 0) {
          var opt = opts[idx];
          if (opt.hasAttribute('data-fish-submit')) {
            commitSearch(q);
            if (q) window.location.href = '/search?type=product&q=' + encodeURIComponent(q);
          } else {
            var link = opt.querySelector('a');
            commitSearch(input.value);
            if (link) { window.location.href = link.getAttribute('href'); }
          }
        } else {
          commitSearch(q);
          if (q) window.location.href = '/search?type=product&q=' + encodeURIComponent(q);
        }
        closeDropdown();
      } else if (e.key === 'Escape') {
        closeDropdown();
        input.blur();
      }
    });

    // ── focus / blur ──────────────────────────────────────────────────────────

    input.addEventListener('focus', function () {
      cancelClose();
      var v = input.value.trim();
      if (v.length >= MIN_QUERY_LEN && dropdown.innerHTML.trim()) {
        openDropdown();
      } else if (v.length === 0) {
        fetchEmptySuggestions();
      }
    });

    input.addEventListener('blur', function () {
      scheduleClose();
    });

    // ── prevent blur when clicking inside dropdown ────────────────────────────

    dropdown.addEventListener('mousedown', function (e) {
      e.preventDefault(); // keeps input focused → no blur → no premature close
    });

    dropdown.addEventListener('touchstart', function (e) {
      cancelClose();
    }, { passive: true });

    // ── click inside dropdown ────────────────────────────────────────────────

    dropdown.addEventListener('click', function (e) {
      var submitBtn = e.target.closest('[data-fish-submit]');
      if (submitBtn) {
        e.preventDefault();
        var q = input ? input.value.trim() : '';
        commitSearch(q);
        window.location.href = '/search?type=product&q=' + encodeURIComponent(q);
        return;
      }
      var link = e.target.closest('a');
      if (link) {
        commitSearch(input.value);
        closeDropdown();
      }
    });

    // ── click outside ────────────────────────────────────────────────────────

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) {
        closeDropdown();
      }
    });
  }

  // ── entry point ────────────────────────────────────────────────────────────

  // Deferred to `load` (18.09.2026, per fish backend dev). bootstrap() fetches
  // /api/v1/search/config on every page (this file loads globally in the
  // header) — was firing at DOMContentLoaded, competing with critical-path
  // rendering. Now edge-cached (~270ms) after the Cloudflare fix, but still
  // shouldn't run before `load`: nothing needs fish predictive search until
  // the shopper focuses the search box, and Dawn's native predictive search
  // (input[type=search] on Search-In-Navbar) covers that gap unaffected.
  if (document.readyState === 'complete') {
    bootstrap();
  } else {
    window.addEventListener('load', bootstrap, { once: true });
  }
})();
